module.exports = __webpack_public_path__ + "img/tipo-portatil.bc08e96b.svg";